// @flow
import { decodeHTML } from 'entities';
import { type Props as FilterTransportProps } from 'Components/widgets/criteria/criteria-transport/filter-transport/FilterTransport.jsx';
import { DEFAULT_DEPARTURE_CITY } from 'Store/trip-criteria/departure-city/constants';
import { getDepartureCities } from 'Utils/faceting/facetingUtils';

export const getDepartureCitiesFromFacets = (
  facets: Array<*>,
  placeholderLabel: string,
): $PropertyType<FilterTransportProps, 'optionsDepartureCities'> => {
  const departureCities = getDepartureCities(facets);

  if (departureCities.length === 0) {
    return [];
  }

  const options = [{ value: '', label: placeholderLabel }];

  const noTransportOption = departureCities.find(city => city.value === DEFAULT_DEPARTURE_CITY);
  if (noTransportOption) {
    const { value, label } = noTransportOption;
    options.push({ value, label: decodeHTML(label) });
  }

  const citiesOptions = departureCities
    .filter(city => city.value !== DEFAULT_DEPARTURE_CITY)
    .map(({ label, value }) => ({
      value,
      label: decodeHTML(label),
    }))
    .sort((a, b) => a.value.localeCompare(b.value));

  return [...options, ...citiesOptions];
};
